import { AudienceSyncScheduleType } from '@/models/audiences';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

type AudienceSyncTypeConfigProps = {
  isFetchingSummary?: boolean;
  realTimeAudienceLeft: number;
  scheduleType: AudienceSyncScheduleType;
  handleChange: (e: React.ChangeEvent<any>) => void;
};

export const AudienceSyncTypeConfig: FunctionComponent<AudienceSyncTypeConfigProps> = ({ realTimeAudienceLeft, scheduleType, handleChange }) => {
  const { t } = useTranslation('ALL');

  const items = [
    {
      id: 'manual',
      value: 'MANUAL',
      disabled: () => realTimeAudienceLeft < 1,
      checked: () => scheduleType === 'MANUAL',
      className: () => `${scheduleType !== 'MANUAL' ? 'opacity-50' : ''}`,
      title: t('manual'),
      description: t('theAudienceWillNotMakeAnyChangesUntilYouExplicitCommand'),
    },
    {
      id: 'scheduled',
      value: 'SCHEDULED',
      disabled: () => realTimeAudienceLeft < 1,
      checked: () => scheduleType === 'SCHEDULED',
      className: () => `${scheduleType !== 'SCHEDULED' ? 'opacity-50' : ''}`,
      title: t('scheduled'),
      description: t('theAudienceIsUpdatedPeriodicallyBasedOnYourSpecifications'),
    },
    // {
    //   id: 'realtime',
    //   value: 'REALTIME',
    //   disabled: () => realTimeAudienceLeft < 1,
    //   checked: () => scheduleType === 'REALTIME',
    //   className: () => `${scheduleType !== 'REALTIME' ? 'opacity-50' : ''}`,
    //   title: (
    //     <Fragment>
    //       Realtime
    //       {isFetchingSummary ? <SpinnerIcon className='ml-2 size-3 text-blue-900' /> : ` (${t('audienceLeftOnYourPlan', { audience: realTimeAudienceLeft })})`}
    //     </Fragment>
    //   ),
    //   description: t('everyUpdateInYourDatasourcesAreAppliedInRealtimeOnThisAudience'),
    // },
  ];

  return (
    <div className='flex flex-col space-y-6 p-6'>
      {items.map((item) => (
        <div className={`${item.className()}`} key={item.id}>
          <label className='flex cursor-pointer flex-row items-start'>
            <input
              type='radio'
              className='mr-3 mt-0.5 size-5 shrink-0 cursor-pointer'
              name='scheduleType'
              id={item.id}
              value={item.value}
              disabled={item.disabled()}
              checked={item.checked()}
              onChange={handleChange}
            />
            <div className='flex flex-col'>
              <span className='flex flex-row items-center font-semibold'>{item.title}</span>
              <p className='mt-1 text-base text-gray-500'>{item.description}</p>
            </div>
          </label>
        </div>
      ))}
    </div>
  );
};
